import React from 'react';
import { gridTheme } from '@utils/grid';
import { Option, Item, StockCheck } from 'shared-types/Common';
import { getCheapestOption } from '@utils/helpers';
import { DescriptionWrapper, ItemDetailsDescriptionWrapper } from './ItemDetailsDescription.styles';
import { ItemPrice } from './ItemPrice';
import { AddToBasketForm, AddToBasketFormProps } from '@features/AddToBasketForm';
import { useIsWindowWiderThan } from '@common/hooks';
import { ContentParser } from '@common/components/ContentParser';

const getCurrentPrice = ({ selectedOption, item, options }) =>
  options?.length ? selectedOption : item;
type ItemDetailsDescription = {
  type: 'product' | 'voucher' | 'event';
  item: Item;
  currentOption?: Option;
  handleBasketUpdate: (any) => void;
  purchaseLimit: number | null;
  optionsFieldName?: string;
  stock?: StockCheck | null;
} & Pick<AddToBasketFormProps, 'isMonetary'>;

/**
 * @deprecated This is for retail specifically, which is to be merged with fulfilables
 */
const ItemDetailsDescription: React.FC<ItemDetailsDescription> = ({
  item,
  currentOption,
  handleBasketUpdate,
  purchaseLimit,
  isMonetary,
  type,
  optionsFieldName,
  stock = null,
}) => {
  const { options } = item;

  const { id } = item;

  const cheapestOption = options?.length ? getCheapestOption(options) : null;

  const initialAddBasketValues = {
    option: null,
    quantity: 1,
    personalization: null,
    [type]: {
      id,
    },
  };

  const selectedOption = currentOption || cheapestOption;

  const currentPrice = getCurrentPrice({
    selectedOption,
    item,
    options,
  });

  const isWiderViewport = useIsWindowWiderThan(gridTheme.breakpoints.lg);

  return (
    <ItemDetailsDescriptionWrapper>
      {!isMonetary && (
        <ItemPrice price={currentPrice} options={options} selectedOption={currentOption} />
      )}
      {!isWiderViewport && (
        <DescriptionWrapper id="product-summary">
          <ContentParser text={item.summaryDescription} />
        </DescriptionWrapper>
      )}
      <AddToBasketForm
        id="addToBasket"
        initialValues={initialAddBasketValues}
        onSubmit={handleBasketUpdate}
        purchaseLimit={purchaseLimit}
        priceToDisplay={currentPrice}
        hideOptionLabel={false}
        isMonetary={isMonetary}
        selectedOption={currentOption}
        optionsFieldName={optionsFieldName}
        type={type}
        item={item}
        stockRemaining={stock}
      />
      {isWiderViewport && (
        <DescriptionWrapper id="product-summary">
          <ContentParser text={item.summaryDescription} />
        </DescriptionWrapper>
      )}
    </ItemDetailsDescriptionWrapper>
  );
};

export { ItemDetailsDescription };
